import { motion } from "motion/react";
import { Shield } from "lucide-react";
import PGVCLo from "../assets/PGVCLo.png";
import dgvclLogo from "../assets/dgvcl-logo.png";

const partners = [
  {
    name: "PGVCL",
    fullName: "Paschim Gujarat Vij Company Limited",
    phase: "Pilot Phase",
    description:
      "Leading electricity distribution company serving millions of consumers with reliable power and innovative green energy solutions.",
    logo: "PGVCL",
    logoUrl: PGVCLo,
    features: [
      ,
      ,
      "Digital Energy Platform",
      "Green Certified",
    ],
  },
  {
    name: "DGVCL",
    fullName: "Dakshin Gujarat Vij Company Limited",
    phase: "Pilot Phase",
    description:
      "Leading electricity distribution company serving consumers across South Gujarat with reliable power and innovative green energy solutions.",
    logo: "DGVCL",
    logoUrl: dgvclLogo,
    features: [
     ,
      ,
      "Digital Energy Platform",
      "Green Certified",
    ],
  },
];

function DiscomCard({ partner }: { partner: (typeof partners)[0] }) {
  return (
    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 h-full flex flex-col">
      <div className="bg-gradient-to-r from-emerald-500 to-cyan-500 p-6 md:p-8 text-white relative overflow-hidden flex-1">
        {/* Pilot Phase Badge */}
        <div className="absolute top-4 right-4">
          <div className="bg-white/20 backdrop-blur-sm border border-white/30 px-4 py-2 rounded-full">
            <span className="text-sm">{partner.phase}</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-6">
          <div className="w-32 h-32 md:w-36 md:h-36 bg-white rounded-2xl flex items-center justify-center shadow-xl flex-shrink-0 p-4">
            <img
              src={partner.logoUrl}
              alt={`${partner.name} Logo`}
              className="w-full h-full object-contain mix-blend-multiply"
            />
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h3 className="text-2xl md:text-3xl mb-2">{partner.name}</h3>
            <p className="text-lg md:text-xl opacity-90 mb-2">
              {partner.fullName}
            </p>
            <p className="opacity-90 text-sm md:text-base">
              {partner.description}
            </p>
          </div>
        </div>
      </div>
      <div className="p-6 md:p-8">
        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {partner.features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center gap-2 bg-gradient-to-br from-emerald-50 to-cyan-50 p-3 md:p-4 rounded-xl"
            >
              <div className="w-7 h-7 md:w-8 md:h-8 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full flex items-center justify-center flex-shrink-0">
                <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-white" />
              </div>
              <span className="text-xs md:text-sm text-gray-700">
                {feature}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function Partners() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-white to-emerald-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl mb-4 bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
            Our Partner DISCOMs
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Partnering with Gujarat's leading electricity distribution companies
          </p>
        </motion.div>

        {/* Partner Cards - Side by Side */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {partners.map((partner) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <DiscomCard partner={partner} />
            </motion.div>
          ))}
        </div>

        {/* Info Note */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-8 text-center"
        >
          <p className="text-sm text-gray-500">
            More DISCOMs coming soon as we expand our green energy network
            across Gujarat
          </p>
        </motion.div>
      </div>
    </section>
  );
}

